export enum ApiUtilsUrls {
  GetParamsFromShortLink = '/saas/v1.0/utils/getparamsfromshortlink',
  Upload = '/saas/v1.0/utils/upload/',
  DeleteTestSessions = '/api/v1.0/utils/deletetestsessions',
  GetFilesForObject = '/saas/v1.0/utils/getfilesforobject',
  DeleteFile = '/saas/v1.0/utils/deletefile',
}
